export const uuid = (): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (<any>crypto).randomUUID();
};
